import React, {Component} from 'react';
import {connect} from "react-redux";
import {PropTypes} from "prop-types";
import {bindActionCreators} from "redux";

import Side from "../../../components/resource/admin/detail/side";

import * as Actions from "../../../store/modules/resources";
import RContent from "../../../components/resource/admin/detail/Rcontent";

class Resource extends Component {
	constructor(props) {
		super(props);
	}

	render() {
		return (
			<div className="container-fluid mt-3 detail-wrap">
				<div className="row">
					<RContent />
					{this.props.showSide !== 'false' &&
					<div className="sidebar-list">
						<Side/>
					</div>
					}
				</div>
			</div>
		)
	}
}

export default connect(
	(state) => ({
		showSide : state.resources.showSide  ? state.resources.showSide  : 'true'
	}),
	(dispatch) => ({
		dataActions: bindActionCreators(Actions, dispatch)
	}),
)(Resource)

Resource.propTypes = {
	activeTab: PropTypes.number
};
